import {ShareState, ShareStatus, ShareStoreType} from '@/stores/ShareStore/ShareStore.types';

import {FrontendError} from '@/services/ErrorService/FrontendError';
import {Store} from '@/stores/Store';

const initialShareState: ShareStoreType = {
  conditionsLink: {status: ShareStatus.Idle},
  projectRef: {status: ShareStatus.Idle},
};

export class ShareStore extends Store<ShareStoreType> {
  constructor() {
    super(initialShareState);
  }

  public setConditionsLinkShareStatus = (shareState: ShareState): void => {
    const newState = {
      ...this.getState(),
      conditionsLink: shareState,
    };
    this.setState(newState);
  };

  public setProjectRefShareStatus = (shareState: ShareState): void => {
    const newState = {
      ...this.getState(),
      projectRef: shareState,
    };
    this.setState(newState);
  };

  public resetConditionsLinkShareStatus = (): void => {
    const newState = {
      ...this.getState(),
      conditionsLink: {status: ShareStatus.Idle},
    };
    this.setState(newState);
  };

  public resetProjectRefShareStatus = (): void => {
    const newState = {
      ...this.getState(),
      projectRef: {status: ShareStatus.Idle},
    };
    this.setState(newState);
  };

  public isConditionsLinkShareStatusSuccess = (): boolean => {
    return this.getState().conditionsLink.status === ShareStatus.Success;
  };

  public isConditionsLinkShareStatusError = (): boolean => {
    return this.getState().conditionsLink.status === ShareStatus.UnknownError;
  };

  public getConditionsLinkShareErrorData = (): FrontendError | undefined => {
    return this.getState().conditionsLink.error;
  };

  public isProjectRefShareStatusSuccess = (): boolean => {
    return this.getState().projectRef.status === ShareStatus.Success;
  };

  public isProjectRefShareStatusError = (): boolean => {
    return this.getState().projectRef.status === ShareStatus.UnknownError;
  };

  public getProjectRefShareErrorData = (): FrontendError | undefined => {
    return this.getState().projectRef.error;
  };
}
